// extracted by mini-css-extract-plugin
module.exports = {"root":"divider_root__YHk4C","subtle":"divider_subtle__LDSHm"};